export default __webpack_public_path__ + "static/media/login-bg.facd51a1.png";